var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('Loading',{attrs:{"type":_vm.current.type},scopedSlots:_vm._u([(_vm.current.message)?{key:"message",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.current.message)+"\n  ")]},proxy:true}:null],null,true)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }